import React, { Component} from "react";


 
/*
class Map extends React.Component {
	  componentDidMount = async () =>{
		
await fetch('./config.json'
    ,{
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       }
    }
    )     .then(function(response){
       
		 
        return response.json();
      })
      .then(function(myJson) {
		  
		url=myJson[0].SERVER_URL;
		alert(url)
       console.log(url)
       Serverurl = url;




      });  
		  
	  }
}

function App1() {
		
fetch('./config.json'
    ,{
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       }
    }
    )     .then(function(response){
       
		 
        return response.json();
      })
      .then(function(myJson) {
		  
		url=myJson[0].SERVER_URL;
		
       console.log(url)
       Serverurl = url;




      });
	const getStateFromChild=url;
}*/


  
export default class Apiurl extends React.Component {
	
	componentDidMount() {
		
	if( localStorage.getItem("ISIurl")===null)
	{	
  fetch('./config.json'
    ,{
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       }
    }
    )     .then(function(response){
       
		 
        return response.json();
      })
      .then(function(myJson) {
		  
		let url=myJson[0].SERVER_URL;
		     
      localStorage.setItem("ISIurl",url)

      });
	  }
	}
	render() {
	
return (

		  <React.Fragment>
		   </React.Fragment>
		   )
	}
}
	
	
	 





 



	
	





